import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Header = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/');
    };

    return (
        <header style={styles.header}>
            <div style={styles.container}>
                <div style={styles.leftSection}>
                    <Link to={user ? '/dashboard' : '/'} style={styles.logoLink}>
                        <img
                            src="/logo-notext.svg"
                            alt="Teachio"
                            style={styles.logoIcon}
                        />
                        <span style={styles.logo}>Teachio</span>
                    </Link>
                </div>
                <div style={styles.rightSection}>
                    {user ? (
                        <div style={styles.userSection}>
                            <Link to="/account" style={styles.userInfo}>
                                <div style={styles.avatar}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                                    </svg>
                                </div>
                                <span style={styles.userEmail}>{user.name || user.email}</span>
                            </Link>
                            <button style={styles.logoutButton} onClick={handleLogout}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                    <polyline points="16 17 21 12 16 7" />
                                    <line x1="21" y1="12" x2="9" y2="12" />
                                </svg>
                                Sign Out
                            </button>
                        </div>
                    ) : (
                        <div style={styles.authButtons}>
                            <Link to="/login" style={styles.loginButton}>Sign In</Link>
                            <Link to="/register" style={styles.registerButton}>Get Started</Link>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};

const styles = {
    header: {
        backgroundColor: 'white',
        borderBottom: '1px solid var(--gray-200)',
        position: 'sticky',
        top: 0,
        zIndex: 100,
    },
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 24px',
        height: '64px',
        maxWidth: '1400px',
        margin: '0 auto',
    },
    leftSection: {
        display: 'flex',
        alignItems: 'center',
    },
    logoLink: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        textDecoration: 'none',
    },
    logoIcon: {
        width: '36px',
        height: '36px',
        borderRadius: 'var(--radius-lg)',
        objectFit: 'contain',
    },
    logo: {
        fontSize: '18px',
        fontWeight: '700',
        color: 'var(--gray-900)',
        letterSpacing: '-0.5px',
    },
    rightSection: {
        display: 'flex',
        alignItems: 'center',
    },
    userSection: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
    },
    userInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        textDecoration: 'none',
    },
    avatar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '32px',
        height: '32px',
        borderRadius: 'var(--radius-full)',
        backgroundColor: 'var(--gray-100)',
        color: 'var(--gray-600)',
    },
    userEmail: {
        fontSize: '14px',
        color: 'var(--gray-600)',
        fontWeight: '500',
        maxWidth: '180px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    logoutButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '8px 14px',
        backgroundColor: 'var(--gray-100)',
        color: 'var(--gray-700)',
        border: 'none',
        borderRadius: 'var(--radius-md)',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all var(--transition-fast)',
    },
    authButtons: {
        display: 'flex',
        gap: '10px',
    },
    loginButton: {
        padding: '8px 16px',
        backgroundColor: 'transparent',
        color: 'var(--gray-700)',
        textDecoration: 'none',
        borderRadius: 'var(--radius-md)',
        fontSize: '14px',
        fontWeight: '500',
        transition: 'all var(--transition-fast)',
    },
    registerButton: {
        padding: '8px 20px',
        background: 'linear-gradient(135deg, var(--primary-500) 0%, var(--primary-600) 100%)',
        color: 'white',
        textDecoration: 'none',
        borderRadius: 'var(--radius-md)',
        fontSize: '14px',
        fontWeight: '600',
        transition: 'all var(--transition-fast)',
        boxShadow: '0 2px 4px rgba(37, 99, 235, 0.2)',
    },
};

export default Header;
